import { globalSettingStore } from '~/stores/GlobalSettingStore';
import { mailDomainStore } from '~/stores/MailDomainStore';
import { api } from '~/stores/providers/Api2';
import { identity, pipe, pluck, prepend } from 'ramda';

class MailDomainActions {
  fetchDomains = () => {
    return api.tenant
      .fetchMailDomains()
      .then(
        pipe(
          pluck('mailDomain'),
          globalSettingStore.env.env === 'ep' ? identity : prepend(window.location.host),
          mailDomainStore.setDomainList
        )
      );
  };
}

export default MailDomainActions;
